import { render, staticRenderFns } from "./RecordingsPage.vue?vue&type=template&id=48549aaa&scoped=true&"
import script from "./RecordingsPage.vue?vue&type=script&lang=js&"
export * from "./RecordingsPage.vue?vue&type=script&lang=js&"
import style0 from "./RecordingsPage.vue?vue&type=style&index=0&id=48549aaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48549aaa",
  null
  
)

export default component.exports